import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=24088426&scoped=true"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=24088426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24088426",
  null
  
)

export default component.exports